import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

interface GroceryHelpTip {
  icon: string;
  titleKey: string;
  descriptionKey: string;
}

/** A mobile tip's leading visual — either a plain icon, or a checked-checkbox demo. */
type GroceryHelpMobileTip =
  | { kind: "icon"; icon: string; titleKey: string; descriptionKey: string }
  | { kind: "checkbox"; titleKey: string; descriptionKey: string };

/**
 * Static "How this list works" explainer, opened from the ⓘ beside the Grocery page title.
 * Renders two content sets — desktop and mobile (`sm:` breakpoint, <640px) — switched purely
 * via CSS visibility (see the template), matching this app's existing responsive convention.
 * Every mobile tip describes behaviour that exists today — keep it that way when editing.
 */
@Component({
  selector: "app-grocery-help-dialog",
  templateUrl: "./grocery-help-dialog.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GroceryHelpDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<GroceryHelpDialogComponent>);

  protected readonly tips: readonly GroceryHelpTip[] = [
    {
      icon: "magnifier",
      titleKey: "groceryHelpTip1Title",
      descriptionKey: "groceryHelpTip1Description",
    },
    {
      icon: "check-circle",
      titleKey: "groceryHelpTip2Title",
      descriptionKey: "groceryHelpTip2Description",
    },
    {
      icon: "info-tooltip",
      titleKey: "groceryHelpTip3Title",
      descriptionKey: "groceryHelpTip3Description",
    },
    {
      icon: "refresh-line",
      titleKey: "groceryHelpTip4Title",
      descriptionKey: "groceryHelpTip4Description",
    },
  ];

  /** Mobile tip set (<640px): tick off / tap a row for actions / archive keeps it / price age. */
  protected readonly mobileTips: readonly GroceryHelpMobileTip[] = [
    {
      kind: "checkbox",
      titleKey: "groceryHelpMobileTip1Title",
      descriptionKey: "groceryHelpMobileTip1Description",
    },
    {
      kind: "icon",
      icon: "more-horizontal",
      titleKey: "groceryHelpMobileTip2Title",
      descriptionKey: "groceryHelpMobileTip2Description",
    },
    {
      kind: "icon",
      icon: "archive",
      titleKey: "groceryHelpMobileTip3Title",
      descriptionKey: "groceryHelpMobileTip3Description",
    },
    {
      kind: "icon",
      icon: "refresh-line",
      titleKey: "groceryHelpMobileTip4Title",
      descriptionKey: "groceryHelpMobileTip4Description",
    },
  ];

  protected dismiss(): void {
    this.dialogRef.close();
  }
}
